/**
 * Schedule utilities for scheduled reports
 */

/**
 * Days of week for weekly schedule selection
 * value: Day index (0 = Sunday, 6 = Saturday)
 * label: Short display label
 * fullLabel: Full day name for accessibility
 */
export const DAYS_OF_WEEK = [
  { value: '0', label: 'S', fullLabel: 'Sunday' },
  { value: '1', label: 'M', fullLabel: 'Monday' },
  { value: '2', label: 'T', fullLabel: 'Tuesday' },
  { value: '3', label: 'W', fullLabel: 'Wednesday' },
  { value: '4', label: 'Th', fullLabel: 'Thursday' },
  { value: '5', label: 'F', fullLabel: 'Friday' },
  { value: '6', label: 'S', fullLabel: 'Saturday' },
];

/**
 * Frequency options for scheduled reports
 */
export const FREQUENCY_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

